export const AppConstants = {
    UPDATE_LANGUAGE: "UPDATE_LANGUAGE",
    UPDATE_THEME: "UPDATE_THEME",
    IS_OPEN_PREFERENCES_MODAL: "IS_OPEN_PREFERENCES_MODAL",
    UPDATE_TENANT: "UPDATE_TENANT",
};
